import { mutator } from 'satcheljs';
import {
    type SET_SHOW_MESSAGE_PREVIEWActionMessage,
    setShowMessagePreview,
} from '../actions/setShowMessagePreviewOption';
import store from '../store/store';

export const setShowMessagePreviewMutator: (
    actionMessage: SET_SHOW_MESSAGE_PREVIEWActionMessage
) => void =
    // eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- BASELINE, do not copy-paste
    mutator(setShowMessagePreview, actionMessage => {
        const optionState = store();
        optionState.showPreviewTextInListView = actionMessage.showPreviewTextInListView;
    });
